/** Portal target for Canvas HD image viewer — scoped to workspace, not document.body. */

export const CANVAS_OVERLAY_ROOT_SELECTOR = '[data-pcv-canvas-overlay-root]'

/** Canvas workspace overlay root (`.pcv-canvas-area`). Falls back to body. */
export function resolveCanvasHiResViewerPortalRoot(): HTMLElement {
  return document.querySelector<HTMLElement>(CANVAS_OVERLAY_ROOT_SELECTOR) ?? document.body
}
